<div class="stream-item" *ngIf="!compact; else compactTemplate">
  <mat-card appearance="outlined" class="stream-item-container">
    <mat-card-content>
      <div class="stream-item-main-section">
        <ng-container *ngTemplateOutlet="streamIcon"></ng-container>
        <div class="stream-item-body">
          <div *ngIf="safeStyles" [innerHTML]="safeStyles"></div>
          <div
            class="body"
            [innerHTML]="safeHtml"
            [ngClass]="{ 'fade-out': !expanded && !readMoreAnimating }"
            [@readMore]="expanded ? 'expanded' : 'collapsed'"
            (@readMore.start)="readMoreAnimating = true"
            (@readMore.done)="readMoreAnimating = false"
            #body
          ></div>
          <div *ngIf="expandable" class="read-more">
            <a *ngIf="!expanded" (click)="expand()">
              {{ 'FRONTEND.LOOP.READ_MORE' | translate }}
            </a>
            <a *ngIf="expanded" (click)="expand()">
              {{ 'FRONTEND.LOOP.READ_LESS' | translate }}
            </a>
          </div>
          <div class="stream-item-footer">
            <span>{{ post.created | date : 'MMM dd, y - h:mm a' }} ({{ fromNow(post.created) }})</span>
          </div>
        </div>
      </div>
      <ng-container>
        <div class="stream-item-actions square">
          <div class="stream-item-reactions">
            <div class="stream-item-reaction">
              <div class="loading" *ngIf="reacting; else reactionBlock">
                <mat-spinner [diameter]="16"></mat-spinner>
              </div>
              <ng-template #reactionBlock>
                <span
                  class="option-container"
                  [class.has-reacted]="hasLiked"
                  (click)="like()"
                  [matTooltip]="likeTooltip"
                  [matTooltipDisabled]="!likeTooltip"
                  matTooltipClass="like-tooltip"
                  matTooltipPosition="after"
                >
                  <mat-icon>thumb_up</mat-icon>
                  <span>{{ likeText }}</span>
                </span>
              </ng-template>
            </div>
            <div class="stream-item-reaction">
              <div class="loading" *ngIf="followingLoading; else followBlock">
                <mat-spinner [diameter]="16"></mat-spinner>
              </div>
              <ng-template #followBlock>
                <span class="option-container" *ngIf="!isFollowing; else followedBlock" (click)="follow()">
                  <mat-icon>add_alert</mat-icon>
                  <span>{{ 'FRONTEND.LOOP.FOLLOW' | translate }}</span>
                </span>
                <ng-template #followedBlock>
                  <span class="option-container is-subscribed" (click)="unfollow()">
                    <mat-icon>notifications_active</mat-icon>
                    <span>{{ 'FRONTEND.LOOP.FOLLOWING' | translate }}</span>
                  </span>
                </ng-template>
              </ng-template>
            </div>

            <div class="stream-item-reaction">
              <span class="option-container" (click)="share()">
                <mat-icon>share</mat-icon>
                <span>{{ 'FRONTEND.LOOP.SHARE' | translate }}</span>
              </span>
            </div>
          </div>
        </div>

        <sales-common-loop-v2-comment-list
          [initialComments]="post.latestComments"
          [typeId]="post.postIdentifier.typeId"
          [postId]="post.postIdentifier.postId"
          (onCommentAdded)="reloadSubscription($event)"
          [currentUser]="currentUser"
          [iconSize]="commentIconSize$ | async"
        ></sales-common-loop-v2-comment-list>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #compactTemplate>
  <div class="compact-post" (click)="clickedPost()">
    <ng-container *ngTemplateOutlet="streamIcon"></ng-container>
    <div>
      <div class="compact-body" [innerHTML]="safeHtml" #body></div>
      <div class="stream-item-footer">
        <span>{{ post.created | date : 'MMM dd, y - h:mm a' }} ({{ fromNow(post.created) }})</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #streamIcon>
  <div class="stream-item-type">
    <ng-container *ngIf="post.icon as icon; else defaultIcon">
      <div class="stream-item-icon">
        <mat-icon *ngIf="icon.matIcon; else iconImage">
          {{ icon.matIcon }}
        </mat-icon>
      </div>

      <ng-template #iconImage>
        <va-icon [iconUrl]="icon.iconPath" [diameter]="postIconSize$ | async"></va-icon>
      </ng-template>
    </ng-container>
    <ng-template #defaultIcon>
      <div class="stream-item-icon">
        <mat-icon>all_inclusive</mat-icon>
      </div>
    </ng-template>
  </div>
</ng-template>
